<template>
  <div class="layer notranslate">
    <button type="button" class="btnClose" @click="close"></button>
    <div class="inner">
      <div class="layerTitle">{{locale.coupon_total}}</div>
      <div class="layerSubTitle colorGrey mb15">{{locale.message_coupon_apply}}</div>
      <div v-if="couponList.length > 0">
        <div v-for="(coupon, index) in couponList"
          :key="index"
          :data-index="index"
          class="couponItem"
          :class="{isChecked: isChecked(coupon.iid)}">
          <input type="checkbox" :id="`check_${coupon.iid}`" :value="coupon.iid" v-model="checked" @change="setCheck($event, coupon.iid)">
          <label :for="`check_${coupon.iid}`">
            <div v-if="coupon.payload && coupon.payload.image" class="image"><img :src="coupon.payload.image" alt=""></div>
            <div class="titleBox">
              <pre class="title" v-if="hasText(coupon.payload.text1[lang])">{{coupon.payload.text1[lang]}}</pre>
              <pre class="describe" v-if="hasText(coupon.payload.text2[lang])">{{coupon.payload.text2[lang]}}</pre>
            </div>
            <p class="checkMessage">{{isChecked(coupon.iid) ? locale.coupon_apply_clear : locale.coupon_apply}}</p>
          </label>
          <div v-if="coupon.iids" class="qty">
            <label :for="`${coupon.iid}_qty`">
            수량:
            <select
              :id="`${coupon.iid}_qty`"
              :disabled="!isChecked(coupon.iid)"
              class="select input inlineInput"
              @change="setCouponQty($event, coupon.cid, coupon.iid)">
              <option value="">1</option>
              <option
                v-for="(iid, index) in coupon.iids"
                :key="iid"
                :value="index + 2"
                :selected="checked.includes(iid)">
                {{index + 2}}
              </option>
            </select>
            </label>
          </div>
        </div>
      </div>
      <p v-else class="noData">{{locale.no_coupons}}</p>
      <div class="btns mt30">
        <button type="button" class="btn btnWhite" @click="close">{{locale.cancel}}</button>
        <button type="button" class="btn" :disabled="isDisabled" @click="apply">{{locale.apply}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  props: [
    'locale',
    'lang',
    'hasChecked',
    'pageId'
  ],
  computed: {
    getUsableCoupon () {
      const usableCoupon = this.$store.getters['page/getUsableCoupon']
      return usableCoupon
    },
    isDisabled () {
      return !this.hasChecked && this.checked.length === 0
    }
  },
  created () {
    // 이 페이지에서 사용 가능한 쿠폰
    this.$store.commit('loading', true)
    this.$store.dispatch('coupon/getCoupon').then((res) => {
      if (res && res.length > 0) {
        const couponList = res.filter(x => { // 해당 페이지에서 사용 가능한 쿠폰 필터
          const usePage = x.payload.usePage && x.payload.usePageIds && x.payload.usePageIds.length > 0
          const pageIds = usePage && x.payload.usePageIds.map(p => p.pageId)
          return usePage && this.pageId && pageIds.includes(this.pageId)
        })
        const getGhost = function (arr) { // 수량선택 가능한 쿠폰 묶음
          let result = []
          for (let i = 0; i < arr.length; i++) {
            const coupon = arr[i]
            if (coupon.payload.allowedQty) {
              const ghost = result.find(x => x.cid === coupon.cid)
              if (ghost && ghost.iids) {
                ghost.iids.push(coupon.iid)
              } else {
                result.push({ ...coupon, iids: [], qty: 1 }) // 0번째 쿠폰 iid는 v-model로 들어가기 때문에 iids에서 제외
              }
            }
          }
          return result
        }
        const ghost = getGhost(couponList)
        this.couponList = couponList.filter(x => !(ghost && ghost.map(g => g.cid).includes(x.cid))).concat(ghost).sort(function (a, b) {
          return a.createat > b.createat ? -1 : a.createat < b.createat ? 1 : 0
        })
        this.coupons = couponList
      } else {
        this.couponList = []
      }
      this.$store.commit('loading', false)
    })
  },
  data () {
    let checked = this.hasChecked || []
    return {
      coupons: [], // 실제 사용처리할 개별쿠폰들
      couponList: [], // 수량선택 가능한 쿠폰묶음 맵핑
      checked
    }
  },
  methods: {
    hasText (text) {
      return regExp.replaceAllEmpty(text).length > 0
    },
    isChecked (iid) {
      return this.checked.includes(iid)
    },
    // 일단 하나만 적용, 1개짜리 배열
    setCheck (e, iid) {
      const isChecked = e.target.checked
      if (isChecked) {
        this.checked = [iid]
      }
    },
    setCouponQty (e, cid, iid) { // iid는 v-model에 속해 있기 때문에 allIids에서 제외
      const coupon = this.couponList.find(x => x.cid === cid)
      const allIids = coupon.iids
      const iids = allIids.filter((x, index) => index < e.target.value - 1)
      this.checked = Array.from(new Set(this.checked.filter(x => !allIids.includes(x)).concat(iids)))
    },
    apply () {
      if (window.confirm(this.locale.confirm_coupon_apply)) {
        this.$emit('apply', this.checked)
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  white-space: initial;
  .inner {
    height: auto;
    max-width: 400px;
    padding: 30px 15px;
    border-radius: 10px;
  }
}
.couponItem {
  position: relative;
  opacity: 0.8;
  &.isChecked {
    border-color: $color-grey;
    opacity: 1;
  }
  input[type="checkbox"] {
    opacity: 0;
  }
  label {
    display: block;
    position: relative;
    padding-top: 40px;
    .checkMessage {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 40px;
      padding-top: 10px;
      padding-left: 40px;
      text-align: left;
      color: $color-grey;
      border-bottom: 1px solid $color-lgrey2;
      background-color: $bg-default;
      &:before {
        content: "";
        position: absolute;
        top: 50%;
        left: 15px;
        width: 18px;
        height: 18px;
        margin-top: -9px;
        border: 1px solid $color-lgrey;
        border-radius: 100%;
        background-color: $color-white;
      }
    }
  }
  :checked + label {
    .checkMessage {
      color: $color-dark;
      &:before {
        border-color: $color-dark;
        background: $color-dark url('~@/assets/img/ico_checked.svg') 50% 50% / 12px no-repeat;
      }
    }
  }
  .qty {
    position: absolute;
    top: 0;
    right: 0;
    background-color: $color-white;
    .input {
      min-height: 39px;
      border: none;
      background: none;
    }
    label {
      padding: 0 10px;
      color: $color-lgrey;
      border-left: 1px solid $color-lgrey2;
    }
  }
}
.noData {
  padding-top: 90px;
  padding-bottom: 90px;
  font-size: 1.2em;
  border-radius: 4px;
  border: 1px solid $color-lgrey2;
  background-color: $color-white;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}
</style>
